import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const ModalSuccessBar = ({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) => (
  <i
    className={cn(
      'absolute left-0 top-0 h-2 w-full bg-[linear-gradient(118deg,#5dbb61,#a3d5a6)]',
      className
    )}
    {...props}
  />
)
